// extracted by mini-css-extract-plugin
export default {"bodyWithFooter":"side_panel_body-module___bodyWithFooter___b1320c0c"};